<template>
  <action-dispatcher
    action="funnel/getTree"
    ref="dispatcher"
    class="funnel-tree-component"
    :parameters="{ id: $route.params.tree }"
  >
    <div class="funnel-header mb-5">
      <h5 class="text-semibold">
        {{ funnelName }}
      </h5>
      <snow-button
        text="Código do widget"
        variant="outline"
        icon="ph ph-code-simple"
        @click="copyWidget"
      />
    </div>
    <div class="funnel-container">
      <funnel-container @dispatch="() => $refs.dispatcher.dispatch()" />
    </div>
    <responsive-modal v-model="modal" size="lg">
      <funnel-form
        @close="modal = false"
        @update="updateFunnelTreeState"
        :funnel="tree[0]"
      />
    </responsive-modal>
  </action-dispatcher>
</template>

<script>
import FunnelContainer from "@/components/product/funnel/FunnelContainer.vue";
import FunnelForm from "@/components/product/funnel/FunnelForm.vue";
import copy from "copy-text-to-clipboard";
import { mapState } from "vuex";

let widget =
  '<iframe id="zeuspay-upsell-iframe"></iframe><script src="https://pay.zeuspay.com.br/static/js/upsell-client.js"><\/script>';
export default {
  components: {
    FunnelContainer,
    FunnelForm
  },
  data() {
    return {
      modal: false
    };
  },
  computed: {
    ...mapState("funnel", ["tree"]),
    ...mapState("product", ["product"]),
    funnelName() {
      return this.tree[0]?.name || "...";
    }
  },
  methods: {
    updateFunnelTreeState(data) {
      let tree = [...this.tree];

      tree[0].name = data.name;
      if (tree[0].offer) this.tree[0].offer.id = data.offer.id;
      if (tree[0].plan) this.tree[0].plan.id = data.plan.id;

      this.$store.commit("funnel/setTree", tree);
    },
    copyWidget() {
      copy(widget);
      this.$message.success("Código copiado.");
    }
  },
  mounted() {
    if (!this.product) {
      this.$store.dispatch("product/getProduct", this.$route.params.id);
    }
  }
};
</script>
<style lang="scss">
.funnel-tree-component {
  .funnel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .funnel-container {
    background: var(--bg-2);
    border-radius: 16px;
    height: 90vh;
  }
}
</style>
